import axios from "axios";

/**
 * All user  authentication / security api and methods goes here
 * More on UIM : https://mswiki.morningstar.com/display/PDS/UIM%3A+Access+Management+%28OpenAM%29+APIs
 */

// TODO : needs to go into some constant file
export const UIM_MS_SSO_KEY = "ms-sso";
export const UIM_SESSION_HOST = process.env.VUE_APP_UIM_SESSION_HOST;
export const API_URL = process.env.VUE_APP_MCP_URL;
export const OAUTH_CALLBACK_HOST = process.env.VUE_APP_OAUTH_CALLBACK_HOST;
export const OAUTH_CALLBACK_URL = process.env.VUE_APP_OAUTH_CALLBACK_URL;

/** Logout api */
export function logout(successUrl) {
  if (!successUrl) {
    throw new Error("successUrl is required.");
  }

  if (!(successUrl instanceof URL)) {
    throw new Error("successUrl should be an instance of URL.");
  }

  const logoutUrl = new URL(
    UIM_SESSION_HOST +
      "/sso/json/logout-browser" +
      "?returnTo=" +
      encodeURIComponent(OAUTH_CALLBACK_URL),
  );

  logoutUrl.searchParams.append("source", "bus0231-ratings-disclosure");
  window.location.href = logoutUrl;
}

/** Me api */
export function me() {
  let url = API_URL + "/users/me";
  return axios.get(url, { withCredentials: true });
}

/** Validate token api */
export function validateUser() {
  let url = API_URL + "/validate-token";
  let headers = {
    "Content-Type": "application/json",
  };

  return axios.post(url, {}, { headers: headers, withCredentials: true });
}

/**
 * Redirect a user to the external Credit Login page.
 * Redirects using window.location.href and operates outside the scope of the Vue Router.
 * @param {URL} successUrl - A URL for the Credit Login page to redirect to upon success.
 */
export function redirectToCreditLogin(successUrl) {
  if (!successUrl) {
    throw new Error("successUrl is required.");
  }

  if (!(successUrl instanceof URL)) {
    throw new Error("successUrl should be an instance of URL.");
  }

  const loginUrl = new URL(UIM_SESSION_HOST + "/sso/json/msusers/app-login");

  loginUrl.searchParams.append("targetUrl", successUrl);
  loginUrl.searchParams.append("source", "bus0231-ratings-disclosure");

  window.location.href = loginUrl;
}
